/**
 * Color palette for tenant visual indicators (10 distinct colors)
 * Chosen for accessibility (WCAG AA contrast on white backgrounds)
 */
const TENANT_COLOR_PALETTE = [
  '#4169E1', // Royal Blue
  '#10B981', // Emerald Green
  '#F59E0B', // Amber
  '#8B5CF6', // Purple
  '#EC4899', // Pink
  '#14B8A6', // Teal
  '#F97316', // Orange
  '#EF4444', // Red
  '#06B6D4', // Cyan
  '#84CC16', // Lime
];

/**
 * Generate a deterministic color for a tenant based on tenant ID
 * Same tenant ID always returns same color
 *
 * @param tenantId - Unique tenant identifier
 * @returns Hex color code
 */
export function getTenantColor(tenantId: string): string {
  // Simple hash: sum of character codes
  const hash = tenantId.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);

  // Use modulo to select from palette
  const colorIndex = hash % TENANT_COLOR_PALETTE.length;

  return TENANT_COLOR_PALETTE[colorIndex];
}

/**
 * Get lighter version of tenant color for backgrounds
 *
 * @param tenantId - Unique tenant identifier
 * @returns Hex color code with reduced opacity
 */
export function getTenantColorLight(tenantId: string): string {
  const color = getTenantColor(tenantId);
  // Convert to rgba with 10% opacity for backgrounds
  return `${color}1A`; // Append alpha in hex (1A = 10% opacity)
}
